module.exports = __webpack_public_path__ + "img/DOCK.d0263136.svg";